import { INPUT_TYPE } from "../../constants/Constant";
import { INPUT_VIEW_DIRECTION } from "../SequenceNumberFormat/Other";

export const SETTINGS_DURATION_OPTIONS = [
    {id:"NA", name:"N.A"},
    {id:"1_week", name:"1 Week"},
    {id:"2_weeks", name:"2 Weeks"},
    {id:"3_weeks", name:"3 Weeks"},
    {id:"4_weeks", name:"4 Weeks"},
    {id:"1_month", name:"1 Month"},
    {id:"2_months", name:"2 Months"},
    {id:"3_months", name:"3 Months"},
    {id:"4_months", name:"6 Months"},
    {id:"1_year", name:"1 Year"},
    {id:"1_year", name:"1 Year"},
];

export const CONFIGURE_COMP_OFF_FIELDS = [
    {columnCode : "isCompOffEnabled", name:"Click to enable Compensatory Off functionality",type:INPUT_TYPE.CHECKBOX},
    {columnCode : "isCompOffEnabledForEmployee", name:"Click to allow employees to Apply Compensatory Off",type:INPUT_TYPE.CHECKBOX},
    // {columnCode : "expiryDuration", name:"Please select duration after which initiated/Applied comp-off will be expired",type:INPUT_TYPE.DROPDOWN, options:SETTINGS_DURATION_OPTIONS, validation:["required"]},
    // {columnCode : "emailToConsumerCompOff", name:"Click to enable email notification to consume unutilized compensatory off before expiry",type:INPUT_TYPE.CHECKBOX}
]

export const MANAGE_COMP_OFF_FIELDS = [
    {columnCode: "workingHoliday", name: "Working Holiday", type: INPUT_TYPE.DATE, validation:['required'], uiVisible:true},
    {columnCode: "duration", name: "Duration", type: 'radio', validation:['required'],uiVisible:true, radioButtons:[{
        fieldId:"halfDay",
        fieldLabel: "Half Day"
    },{
        fieldId:"fullDay",
        fieldLabel: "Full Day"
    }]},
    {columnCode: "expiryMode", name: "Expiry Mode", type: 'radio', validation:['required'],uiVisible:true, radioButtons:[{
        fieldId:"noOfDays",
        fieldLabel: "No. of Day(s)"
    },{
        fieldId:"date",
        fieldLabel: "Date"
    }]},
    {columnCode: "expiryAt", name: "Expiry In (Days)", type: INPUT_TYPE.NUMBER, validation:['required', 'greaterThan'], uiVisible:true, greaterThanField :  [{key : "workingHoliday", name: "Working Holiday"}]},
    {columnCode: "description", name: "Description", type: INPUT_TYPE.TEXT, uiVisible:true},
    {columnCode: "isForAllUsers", name: "Is For All Users", type: INPUT_TYPE.DROPDOWN, validation:['required'],options:[{"id":"Y", name:"Yes"},{id:"N",name:"No"}], uiVisible:true},
    {columnCode: "compOffFor", name: "Comp Off For", type: INPUT_TYPE.DROPDOWN, validation:['required'], isMultiSelect: true,uiVisible:true},
    {columnCode: "isAttachmentMandatory", name: "Required Attachment", type: INPUT_TYPE.DROPDOWN, validation:['required'],options:[{"id":true, name:"Yes"},{id:false,name:"No"}], uiVisible:true,tooltipMsg:"Required employees to attach the proof for working on a holiday"},
]

export const COMP_OFF_REQUEST_FILTER = [
    {
      id: "all",
      name: "All",
      searchField: "",
    },
    {
      id: "APPROVED",
      name: "Approved",
      searchField: "APPROVED",
    },
    {
      id: "REJECTED",
      name: "Rejected",
      searchField: "REJECTED",
    },
    {
      id: "PENDING",
      name: "Pending",
      searchField: "PENDING",
    }
  ];
  

  export const LOCATION_COLUMN_CONFIG = {
    name: '',
    type: 'select',
    index: 4,
    options: [],
    required: false,
    width: 150,
    editable: false,
    hidden: false,
    uiVisible: true,
    columnCode: '',
    key: '',
    id: '',
    allowAddOption : false
  }

  export const APPLY_COMP_OFF = [
      {columnCode:"", name: "",type:"", validation:[],}
  ]
  export const APPLY_COMP_OFF_FIELDS = [
    {
      key: "employees",
      columnCode: "employees",
      options: [],
      icon: "",
      validation: null,
      isValid: true,
      name: "Employee",
      type: INPUT_TYPE.DROPDOWN,
      errorMessage: null,
      direction: INPUT_VIEW_DIRECTION.VERTICAL,
      required: true,
      readOnly: false,
      uiVisible: true,
      isValid:true
    },
    {
      key: "compOff",
      columnCode: "compOff",
      options: [],
      icon: "",
      validation: null,
      isValid: true,
      name: "Comp-Off",
      type: INPUT_TYPE.DROPDOWN,
      errorMessage: null,
      direction: INPUT_VIEW_DIRECTION.VERTICAL,
      required: true,
      readOnly: false,
      uiVisible: true,
      multiSelect: true,
      isValid:true
    },
    {
      columnCode: "leaveDate",
      name: "Leave Date",
      type: 'date',
      validation: ['required'],
      readOnly:false,
      required:true,
      uiVisible: true,
      isValid:true
    },
    {
      columnCode: "duration",
      name: "Duration",
      type: 'radio',
      validation: ['required'],
      readOnly:false,
      required:true,
      uiVisible: true,
      radioButtons: [{
        fieldId: "halfDay",
        fieldLabel: "Half Day"
      },
      {
        fieldId: "fullDay",
        fieldLabel: "Full Day"
      }],
      isValid:true
    },
    {
      columnCode: "description",
      name: "Description",
      type: INPUT_TYPE.TEXT,
      validation: ['required'],
      required:true,
      uiVisible: true,
      isValid:true
    },
    {
      columnCode: "attachments",
      name: "Attachment",
      type: 'file',
      required:false,
      uiVisible: true,
      tooltiptext: 'Please select and upload valid file.',
      isValid:true
    }
  ]
  
  export const STATUS_COMP_OFF = {
    APPROVED: 'APPROVED',
    PENDING:'PENDING',
    REJECTED: 'REJECTED'
  }